export default "__VITE_ASSET__DWXXjLhB__"